import React, { PropsWithChildren } from 'react';
import { MappedComponentProperties } from '@adobe/aem-react-editable-components';

import './TermsTable.css';
import { transformHTMLParserLinks } from '../../utils/rewriteLink/rewriteLink';
import { wrapTrademarkSuperscript } from '../../utils/cob-utils';
import { Row, Col, Container } from '../../importCL';


interface ITermsTableProps extends MappedComponentProperties {
    title?: string;
    topLeftDescription?: string;
    topRightDescription?: string;
    middleDescription?: string;
    bottomDescription?: string;
}

export const TermsTableEditConfig = {
    emptyLabel: 'TermsTable',
    isEmpty: (props: PropsWithChildren<ITermsTableProps>) => {
        return !props || (!props.title && !props.topLeftDescription && !props.topRightDescription && !props.middleDescription && !props.bottomDescription);
    },
};

const TermsTable = (props: PropsWithChildren<ITermsTableProps>): JSX.Element => {
    return (
        <div id='terms-table' className='TermsTable'>
            <Container>
                <fieldset className='TermsTable__fieldset'>
                    <legend> {transformHTMLParserLinks(wrapTrademarkSuperscript(props.title ?? 'Terms Table'))}</legend>
                    <Row className='TermsTable__row'>
                        <Col className='TermsTable__col--border'>
                            {props.topLeftDescription && transformHTMLParserLinks(wrapTrademarkSuperscript(props.topLeftDescription))}
                        </Col>
                        <Col className='TermsTable__col--border'>
                            {props.topRightDescription && transformHTMLParserLinks(wrapTrademarkSuperscript(props.topRightDescription))}
                        </Col>
                    </Row>
                    <Row className='TermsTable__row'>
                        <Col className='TermsTable__col--border TermsTable__col--cpOption'>
                            {props.middleDescription && transformHTMLParserLinks(wrapTrademarkSuperscript(props.middleDescription))}
                        </Col>
                    </Row>
                    <Row className='TermsTable__row'>
                        <Col className='TermsTable__col--border'>
                            {props.bottomDescription && transformHTMLParserLinks(wrapTrademarkSuperscript(props.bottomDescription))}
                        </Col>
                    </Row>
                </fieldset>
            </Container>
        </div>);
};

export default TermsTable;
